import { render, staticRenderFns } from "./orderCancel.vue?vue&type=template&id=503f8b68&scoped=true&"
import script from "./orderCancel.vue?vue&type=script&lang=js&"
export * from "./orderCancel.vue?vue&type=script&lang=js&"
import style0 from "./orderCancel.vue?vue&type=style&index=0&id=503f8b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503f8b68",
  null
  
)

export default component.exports